<mat-tab-group
  [(selectedIndex)]="currentIndex"
  *ngIf="supportedLanguages && notSingleDefaultLanguage"
  (selectedTabChange)="onTabChange($event)"
>
  <mat-tab
    *ngFor="let supportedLanguage of supportedLanguages"
    [attr.aria-label]="
      supportedLanguage.language.name +
      (supportedLanguage.isDefault ? ' (' + ('translations.language.tabs.defaultSuffix' | transloco) + ')' : '')
    "
  >
    <ng-template mat-tab-label>
      <div class="tab-click f_language-tab" [attr.language-code]="supportedLanguage.language.code"></div>
      {{ supportedLanguage.language.name }}&nbsp;
      <strong *ngIf="supportedLanguage.isDefault"> ({{ 'translations.language.tabs.defaultSuffix' | transloco }}) </strong>
    </ng-template>
  </mat-tab>
</mat-tab-group>
